export const STORE_AUTH_TOKEN = 'tk-auth-token';
export const STORE_IMPERSONATE = 'tk-impersonate';
export const STORE_USER = 'tk-user';
export const STORE_LANG = 'tk-lang';
export const STORE_CART_ITEMS = 'tk-cart-items';
export const STORE_ARTWORK_REACTION = 'tk-store-artwork-reaction';
export const VISITS_COUNTER = 'tk-visits-counter';
export const COOKIE_CONSENT = 'tk-cookie-consent';
export const ROUTE_QUERY = 'tk-route-query';

// Events key
export const ROUTE_QUERY_EVENT = 'tk-route-query-event';
export const MOBILE_SEARCH_BUTTON_EVENT = 'tk-mobile-search-button-event';
